function initMobileMenu(){
    //Mobi menu
    $('body .hamburger').on('click',function () {
        $('body').toggleClass('mobi-menu-open')
        $(this).toggleClass('is-active')
        var windowHeight = $(window).height();
        var linksHeight = $('.header-top .header-links').first().outerHeight(true);
        var logoHeight = $('.header-top .logo').first().outerHeight(true);
        $('.page-header .navbar-main').css('height',parseInt(windowHeight - linksHeight - logoHeight) + 1 + 'px')
    })

    //touch devices 2 tap link / hover

    $('.navbar-main .link.subs').on('touchstart',function (e) {
        //so the event on window will not be triggerd
        e.stopPropagation();
       if($(this).parent().hasClass('touched') === false){
           e.preventDefault();
           $(this).parent().addClass('touched')
       }
    });

    $(window).on('touchstart',function() {
        $('.navbar-main .subs').removeClass('touched')
    });

}

function is_touch_device() {
    if ("ontouchstart" in window || window.TouchEvent)
        return true;

    if (window.DocumentTouch && document instanceof DocumentTouch)
        return true;

    const prefixes = ["", "-webkit-", "-moz-", "-o-", "-ms-"];
    const queries = prefixes.map(prefix => `(${prefix}touch-enabled)`);

    return window.matchMedia(queries.join(",")).matches;
}